import type { FC } from 'react';

interface FlocktoryProductProps {
  productId: string | number | null | undefined;
}

const FlocktoryProduct: FC<FlocktoryProductProps> = ({ productId }) => {
  if (productId == null || productId === '') {
    return null;
  }

  return (
    <div
      className='i-flocktory'
      data-fl-action='track-item-view'
      data-fl-item-id={String(productId)}
    />
  );
};

export default FlocktoryProduct;
